/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LineItemSelectedVariantOption
 */
export interface LineItemSelectedVariantOption {
    /**
     * 
     * @type {string}
     * @memberof LineItemSelectedVariantOption
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemSelectedVariantOption
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItemSelectedVariantOption
     */
    id?: number;
}

/**
 * Check if a given object implements the LineItemSelectedVariantOption interface.
 */
export function instanceOfLineItemSelectedVariantOption(value: object): boolean {
    return true;
}

export function LineItemSelectedVariantOptionFromJSON(json: any): LineItemSelectedVariantOption {
    return LineItemSelectedVariantOptionFromJSONTyped(json, false);
}

export function LineItemSelectedVariantOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemSelectedVariantOption {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'value': json['value'] == null ? undefined : json['value'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function LineItemSelectedVariantOptionToJSON(value?: LineItemSelectedVariantOption | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'value': value['value'],
        'id': value['id'],
    };
}

